/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { FC, useState } from 'react';
import { coreService } from 'network-utils';
import LeaderboardFullExpand from './leaderboardFullExpand/leaderboard';
import LeaderboardCollapsed from './leaderboardCollapsed';
import LeaderboardExpand from './leaderboardExpand/leaderboardExpand';

const Leaderboard: FC<LeaderboardProps> = (props: LeaderboardProps) => {
    const { usersLeaderboard, teamsLeaderboard, onlyUsers } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [isExpandedFull, setIsExpandedFull] = useState(false);

    return (
        <div>
            {isExpanded ? (
                <LeaderboardExpand
                    users={usersLeaderboard?.results || []}
                    teamsLeaderboard={teamsLeaderboard?.teams || []}
                    onUnexpanded={setIsExpanded}
                    onFullExpand={setIsExpandedFull}
                    onlyUsers={onlyUsers}
                />
            ) : isExpandedFull ? (
                <LeaderboardFullExpand onUnExpand={setIsExpanded} onClose={setIsExpandedFull} />
            ) : (
                <LeaderboardCollapsed rank={usersLeaderboard?.currentUser?.rank || 0} onExpand={setIsExpanded} />
            )}
        </div>
    );
};

interface LeaderboardProps {
    usersLeaderboard: coreService.HomeLeaderboardResponse | undefined;
    teamsLeaderboard: coreService.HomeTeamLeaderboardResponse | undefined;
    onlyUsers: boolean;
}

export default Leaderboard;
